import React, { useRef } from 'react';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import {
  DisableUpdatingPreviousWhereaboutsSetting
} from '@shared/ui/organisms/settings/DisableUpdatingPreviousWhereaboutsSetting';
import { EditingFutureWhereaboutsSettings } from '@shared/ui/organisms/settings/EditingFutureWhereaboutsSettings';
import { CalendarSyncSetting } from '@shared/ui/organisms/settings/CalendarSyncSetting';
import { PrivateGroupsSetting } from '@shared/ui/organisms/settings/PrivateGroupsSetting';
import { RestrictTeamManagement } from '@shared/ui/organisms/settings/RestrictTeamManagement';
import {
  HidePastWhereaboutsSetting,
  HidePastWhereaboutsSettingHandle,
} from './HidePastWhereaboutsSetting';
import { SectionSaveButton } from './SectionSaveButton';

export function WhereaboutsVisibilityPanel() {
  const hidePastWhereaboutsRef = useRef<HidePastWhereaboutsSettingHandle>(null);

  const onSave = async () => {
    await hidePastWhereaboutsRef.current?.save();
  };

  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>Whereabouts management</HeadlineSmall>
      <EditingFutureWhereaboutsSettings />
      <DisableUpdatingPreviousWhereaboutsSetting />
      <HidePastWhereaboutsSetting ref={hidePastWhereaboutsRef} />
      <PrivateGroupsSetting />
      <RestrictTeamManagement />
      <CalendarSyncSetting />
      <SectionSaveButton onSave={onSave} />
    </>
  );
}
